import { httpClient, Service } from "./client";

class BulkIngestService extends Service {
  private basePath = "/bulkingest/jobs";

  list() {
    return httpClient.get(this.basePath, this.authHeader());
  }

  getById(jobId: string) {
    return httpClient.get(`${this.basePath}/${jobId}`, this.authHeader());
  }

  listFiles(jobId: string) {
    return httpClient.get(`${this.basePath}/${jobId}/files`, this.authHeader());
  }

  create(name: string, description?: string) {
    return httpClient.post(
      this.basePath,
      { name, description },
      this.authHeader()
    );
  }

  getUploadUrl(jobId: string, fileName: string, contentType?: string) {
    return httpClient.post(
      `${this.basePath}/${jobId}/upload-url`,
      { fileName, contentType },
      this.authHeader()
    );
  }

  validate(jobId: string) {
    return httpClient.post(
      `${this.basePath}/${jobId}/validate`,
      {},
      this.authHeader()
    );
  }

  start(
    jobId: string,
    selection: { entitlements?: string[]; contentChannels?: string[] }
  ) {
    return httpClient.post(
      `${this.basePath}/${jobId}/start`,
      selection,
      this.authHeader()
    );
  }

  retry(jobId: string) {
    return httpClient.post(
      `${this.basePath}/${jobId}/retry`,
      {},
      this.authHeader()
    );
  }

  /** Ask the orchestrator to stop the job. Idempotent: a second call is a 200 no-op. */
  cancel(jobId: string) {
    return httpClient.patch(
      `${this.basePath}/${jobId}`,
      { status: "cancelling" },
      this.authHeader()
    );
  }

  close(jobId: string) {
    return httpClient.post(
      `${this.basePath}/${jobId}/close`,
      {},
      this.authHeader()
    );
  }

  remove(jobId: string) {
    return httpClient.delete(`${this.basePath}/${jobId}`, this.authHeader());
  }
}

export const bulkIngestService = new BulkIngestService();
